import { render, staticRenderFns } from "./order-personal-data-login.component.vue?vue&type=template&id=71c9bf66&"
import script from "./order-personal-data-login.component.vue?vue&type=script&lang=ts&"
export * from "./order-personal-data-login.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "order-personal-data-login.component.vue"
export default component.exports